module.exports = __webpack_public_path__ + "static/img/bq001.ed21fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/bq001.png
// module id = 6fYG
// module chunks = 1